import React from 'react';
import { CadFeatureMap } from '@mark43/cad-api';
import { EnabledFeaturesContext } from './enabled-features-context';
import { getDevAllEnabledFeatures } from '@m43/core';

export function useEnabledFeatures(): CadFeatureMap {
    const enabledFeatures = React.useContext(EnabledFeaturesContext);
    if (!enabledFeatures) {
        throw new Error('Unexpectedly did not find enabledFeatures on context.');
    }
    const allDevEnabledFeatures = getDevAllEnabledFeatures();
    if (allDevEnabledFeatures !== undefined) {
        return { ...enabledFeatures, ...allDevEnabledFeatures };
    }
    return enabledFeatures;
}
